/**
 * Mapping from the complexity band to the progress bar's fill (MUS-401).
 */

/**
 * The `crMax` a band has when the user reaches the chevron activation
 * threshold.
 *
 * Under the centred window `crMax` is `position + cvr/2`, so at the shipping
 * CAT of 0.8 and CVR of 0.2 it reads 0.9.
 */
export const CRMAX_AT_CHEVRON_ACTIVATION = 0.9;

/**
 * Progress toward chevron activation, from the band the phrase now playing was
 * planned with, clamped to [0, 1].
 *
 * Interim. MUS-401 wants this anchored to the band's `position`, but the
 * Phaser -> React event carries only `crMin`/`crMax` today, so it normalises
 * against {@link CRMAX_AT_CHEVRON_ACTIVATION} instead. Swap to `position / cat`
 * once the event carries position; the figure is unaffected either way, since
 * it takes a fraction and knows nothing about CAT.
 */
export function fillFractionFromBand(band: { crMin: number; crMax: number } | null): number {
  if (band == null) return 0;
  const fraction = band.crMax / CRMAX_AT_CHEVRON_ACTIVATION;
  return Math.min(Math.max(fraction, 0), 1);
}
